import { Component, OnInit } from '@angular/core';
const data = {
  chart: {
    aligncaptionwithcanvas: '0',
    plottooltext: '<b>$dataValue</b> leads received',
    theme: 'fusion',
    numberSuffix: '%',
    paletteColors: '#428DFF',
    bgColor: '#fdfdfd',
    showvalues: '1',
    placevaluesinside: '0',
    maxBarHeight: '6'

  },
  data: [
    {
      label: 'Coffee Lovers',
      value: '27'
    },
    {
      label: 'Mall Visitors',
      value: '25'
    },
    {
      label: 'Gym Users',
      value: '23'
    },
    {
      label: 'Pub Visitors',
      value: '18'
    }
  ]
};
@Component({
  selector: 'app-simple-bar-chart',
  templateUrl: './simple-bar-chart.component.html',
  styleUrls: ['./simple-bar-chart.component.scss']
})
export class SimpleBarChartComponent implements OnInit {
  width = '100%';
  height = 400;
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = data;
  constructor() { }

  ngOnInit() {
  }

}
